export default "__VITE_ASSET__BTZNctCC__"